<template>
  <div class="">
    <div class="topHeader">
      <img src="/static/img/index/back.png" alt="" class="backImg" @click="goBack()" />
      <div class="title">经典钥匙</div>
    </div>
    <!-- <img src="/static/img/index/back.png" alt="" class="backBtn" @click="goBack()" /> -->
    <div class="sellingTimeContent">
      <div class="videopo" v-if="detail.tags == '视频' || detail.tags == '音乐'">
        <template v-if="detail.showmodel == 1 && detail.isscenemodel == 0">
          <detail3D v-if="!detail.opusmodelissupportanimaiton"></detail3D>
          <detail3DAnimate v-else></detail3DAnimate>
        </template>
        <template v-else>
          <videoModel class="videoBox" v-if="showVideoBox" :dataObj="dataObj" :isFullscreen="false"
            @YHhideFun="YHhideFun"></videoModel>
        </template>
      </div>
      <div class="vediourlImgWrap" v-else-if="detail.tags == '图片'">
        <template v-if="detail.showmodel == 1 && detail.isscenemodel == 0">
          <detail3D v-if="!detail.opusmodelissupportanimaiton"></detail3D>
          <detail3DAnimate v-else></detail3DAnimate>
        </template>
        <template v-else>
          <img :src="detail.vediourl" alt="" class="vediourlImg" />
        </template>
      </div>

      <div class="con">
        <div class="topTitle">
          <div class="product-name">
            {{ detail.name }}
          </div>
        </div>
        <Unfold :data="detail.intro" maxLen=75 style="margin-top:25px" />
      </div>
      <div class="price">
        <span>￥</span>
        <b>{{detail.price | filterMoney}}</b>
      </div>
      <div class="conTwo">
        <div class="title">商品详情</div>
        <div v-html="detail.detail"></div>
      </div>

    </div>

    <div class="musicHome" @click="downloadApp">
      <span>进入音乐空间</span>
      <img src="/static/img/boxdetail/musicHomeSj.png" class="img2" alt="">
    </div>

    <div class="boxStatus">
      <div type="primary" @click="nowBuyBtn" class="btn activebtn">
        立即购买
      </div>
    </div>

    <d-confirm v-model="modal" :loading="loading" :content="$t('boxDetail.modal')"
      :ok-text="$t('boxDetail.modalOkText')" :cancel-text="$t('boxDetail.modalCancelText')" @on-ok="handleokConfirm"
      @on-cancel="handleokPay" ok-color="#f5f5f9" cancel-color="#1ce89e"></d-confirm>

    <!-- 批量购买相关ui -->
    <div class="batchPop" v-if="batchModal">
      <div class="batchPopModal">
        <img src="/static/img/boxdetail/batchClose.png" alt="" class="batchCloseIcon" @click="batchModal = false">
        <div class="text1">{{$t('boxDetail.selectCount') }}</div>
        <div class="buyNumDiv">
          <div class="buyLeft">
            {{  $t('boxDetail.gm') }}{{$t('infiniteBoxDetail.count') }}<span>{{  $t('infiniteBoxDetail.moreBuy') }}{{limitbuycount}}{{$t('boxDetail.a') }}</span>
          </div>
          <div class="buyRight">
            <div class="batchPlusDiv" @click="plusDiv()">
              <img src="/static/img/boxdetail/batchPlus.png" alt="" class="batchPlusIcon">
            </div>
            <input type="number" value="num" v-model="num" class="numInput" @blur="numBlur" @paste="paste">
            <div class="batchAddDiv" @click="addDiv()">
              <img src="static/img/boxdetail/batchAdd.png" alt="" class="batchAddIcon">
            </div>
          </div>
        </div>
        <div class="sureBuyBtn active" @click="nowBuy">
          {{$t('infiniteBoxDetail.buy') }}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import videoModel from "@/components/videoModel";
  import Unfold from "@/components/Unfold.vue";
  import detail3D from "@/components/detail3D.vue";
  import detail3DAnimate from "@/components/detail3DAnimate";
  let Base64 = require("js-base64").Base64;
  import {
    formatDate
  } from "@/common/format.js";
  export default {
    name: "ProdDetail",
    components: {
      videoModel,
      detail3DAnimate,
      Unfold,
      detail3D
    },
    data() {
      return {
        modal: false, // 有未支付订单弹窗
        loading: false,
        payinfo: {},
        limitbuycount: "1", //最大购买数
        num: 0,
        isdisabled: false,
        totalPrice: "",
        batchModal: false, //批量购买弹窗
        isInApp: false,
        batchModal: false, //批量购买弹窗

        base: this.$store.state.token && Base64.decode(this.$store.state.token.split(".")[1]),
        showVideoBox: true,
        dataObj: {
          id: "",
          opusattrid: "",
          userId: 0,
          show3DpageBtn: false,
        },
        sharemodal: {
          value: false,
        },
        //弹窗里是否显示下载按钮
        loading: false,
        detail: {

        },

      };
    },
    watch: {
      num(val) {
        if ((val - 0) > this.limitbuycount) {
          this.num = this.limitbuycount
          var bit = this.$i18nn.t('boxDetail.gm');
          this.$toast({
            message: this.$i18nn.t('boxDetail.uMost') + bit + this.limitbuycount + this.$i18nn.t('boxDetail.a'),
            duration: 1500,
          });
          return false; //是，停止动作
        } else if (val <= 0) {
          this.num = 0
          return false; //是，停止动作
        }
      },
      batchModal(val) {
        if (val) {
          this.stop();
        } else {
          this.move();
        }
      },
    },
    filters: {
      subStr(num) {
        return num.substring(0, 1);
      },
      //分转元
      filterMoney(num) {
        return (num / 100).toFixed(2);
      },
    },

    methods: {
      webviewOnFinished(data) {
        this.$toast({
          message: JSON.stringify(data),
        });
        setTimeout(() => {
          this.getData();
        }, 1000)
      },
      //点击加号
      addDiv() {
        if (parseInt(this.num) >= this.limitbuycount) {
          //判断input中得值是否小于1
          var bit = this.$i18nn.t('boxDetail.gm');
          this.$toast({
            message: this.$i18nn.t('boxDetail.uMost') + bit + this.limitbuycount + this.$i18nn.t(
              'boxDetail.a'),
            duration: 1500,
          });
          return false; //是，停止动作
        }
        this.num = this.num + 1;
      },
      plusDiv() {
        if (parseInt(this.num) <= 1) {
          //判断input中得值是否小于1
          return false; //是，停止动作
        }
        this.num = this.num - 1;
      },
      //立即购买
      nowBuy() {
        let that = this;

        if (!this.num) {
          this.$toast({
            message: this.$i18nn.t('boxDetail.slbnwk') //数量不能为空,
          });
          return
        }
        if (this.isdisabled) {
          return false;
        }
        that.totalPrice = this.$tool.accMul(that.num, that.detail.price);
        if (that.$store.state.token) {
          that.isdisabled = true;
          // 查看是否有待支付订单
          that.queryUnPayFn(function (data) {
            that.isdisabled = false;
            if (data == "noOrder") {
              let formdata = {
                id: Number(that.$route.query.id),
                count: Number(that.num),
              };
              //下单
              that.$fetchql.Post("opus/goods/order", formdata).then((result) => {
                sessionStorage.setItem("CURBOXID", that.$route.query.id);
                sessionStorage.setItem("CURBOXPATH", that.$route.path);
                that.isdisabled = false;
                if (result.code == 0) {
                  let data = result.data;
                  if (!data) {}
                  if (data.orderNo) {
                    that.$router.push({
                      path: "/appPayment",
                      query: {
                        id: that.$route.query.id,
                        type: 1,
                        orderno: result.data.orderNo,
                        redirect: that.$route.fullPath
                      },
                    });
                  }
                }
              });
            }
          });
        } else {
          this.$router.push({
            path: "/login",
            query: {
              redirect: this.$route.fullPath,
            },
          });
        }

      },
      nowBuyBtn() {
        // this.showBatchModal();
        // return
        if (this.isInApp) {
          this.$bridge.callhandler("getUserToken", {}, (token) => {
            if (token) {
              this.$store.setstate.token(token);
              this.showBatchModal();
            } else {
              this.$store.setstate.token("");
              this.$bridge.callhandler("getLogin", {}, (token) => {});
            }
          });
        }
      },
      showBatchModal() {
        this.$fetchql.Post("opus/goods/canBuyCount", {
          id: this.$route.query.id - 0
        }).then((result) => {
          if (result.code == 0) {
            if (result.data == -1) {
              this.limitbuycount = 30; // 默认30个
            } else {
              this.limitbuycount = result.data;
            }
            this.batchModal = true;
          }
        })
      },
      numBlur(val) {
        console.log(this.num)
        if (!this.num) {
          this.num = 1;
        }
      },
      paste(e) {
        e.preventDefault()
        return ""
      },
      /**
       * 查看是否有未支付订单
       */
      queryUnPayFn(callBack) {
        var that = this;
        that.$fetchql
          .Post('opus/goods/order/unPay', {
            id: Number(that.$route.query.id * 1),
          })
          .then((res) => {
            if (res.code == 0 && res.data.exist) {
              that.payinfo = res.data;
              that.modal = true;
              callBack && callBack("hasOrder");
            } else {
              callBack && callBack("noOrder");
            }
          });
      },
      // 支付待支付订单
      handleokPay() {
        this.modal = false;
        sessionStorage.setItem("CURBOXID", this.$route.query.id);
        sessionStorage.setItem("CURBOXPATH", this.$route.path);
        this.$router.push({
          path: "/appPayment",
          query: {
            id: this.$route.query.id,
            type: 1,
            orderno: this.payinfo.orderno,
            status: this.payinfo.status,
            redirect: this.$route.fullPath
          },
        });
      },
      //取消订单
      handleokConfirm() {
        let that = this;
        let data = {
          orderno: that.payinfo.orderno,
          ordertype: 1,
          remark: '用户手动取消boxDetail页面',
        };
        this.loading = true;
        //取消订单
        that.$fetchql.Post("opus/goods/order/cancel", data, "noMsg").then((result) => {
          if (result.code == 0) {
            setTimeout(() => {
              this.modal = false;
              this.loading = false;
              location.reload()
            }, 300);
          } else {
            this.$toast({
              message: result.message,
            });
          }
        });
      },
      downloadApp() {
        if (this.isInApp) {
          // 获取app token
          this.$bridge.callhandler("getUserToken", {}, (token) => {
            if (token) {
              this.$store.setstate.token(token);
              this.$bridge.callhandler("toMusicSpace", {}, (appRes) => {});
            } else {
              this.$store.setstate.token('')
              this.$bridge.callhandler("getLogin", {}, (token) => {});
            }
          });
        }
      },

      goBack() {
        if (this.isInApp) {
          this.$bridge.callhandler("onClose", {}, (token) => {});
        }
      },
      //禁止滚动
      stop() {
        document
          .getElementsByTagName("body")[0]
          .setAttribute("style", "position:fixed; width:100%;font-size:12px");
      },
      /***取消滑动限制***/
      move() {
        document
          .getElementsByTagName("body")[0]
          .setAttribute("style", "position:relative;font-size:12px");
      },


      getData() {
        //作品详情
        let that = this;
        that.$loading.show();
        that.$fetchql
          .Post('opus/goods/info', {
            id: that.$route.query.id * 1,
          })
          .then((res) => {
            that.$loading.hide();
            let data = res.data;
            var obj = {
              id: that.$route.query.id,
              opusattrid: 0,
              show3DpageBtn: false,
              userId: 0,
              isDownload: false,
            };
            that.dataObj = Object.assign(that.dataObj, obj);
            if (data.opusstorage && data.opusstorage.length) {
              data.opusstorage.forEach((item) => {
                item.externalurl = that.$baseUrl + item.externalurl;
                if (item.opustype == 1) {
                  data.vediourl = item.externalurl;
                } else if (item.opustype == 2) {
                  data.vediourl = item.externalurl;
                }
              });
            }
            if (data.creatorlist) {
              if (data.creatorlist[0]) {
                data.creatorlist[0].birthday &&
                  (data.creatorlist[0].birthday =
                    data.creatorlist[0].birthday.replace(
                      reg,
                      "/"
                    ));
              }
            }
            data.qty = res.data.qty;
            that.detail = data
          });
      },
    },
    deactivated() {
      this.move();
    },
    beforeDestroy() {
      this.move();
    },
    destroyed() {
      this.move();
    },
    mounted() {
      let that = this;
      let u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      window.scrollTo(0, 0);
      if (isAndroid) {
        // window.webviewOnFinished = this.webviewOnFinished
        setTimeout(() => {
          this.getData();
        }, 1500)
      }
      if (isiOS) this.getData();
      this.move();

      //判断是否在app内部打开

      if (u.indexOf('mints') != -1) {
        this.$bridge.callhandler("hideNavigationBar", {}, (res) => {})

        this.$bridge.callhandler("inApp", "周杰伦DEMO空间", (res) => {
          this.isInApp = res;
          if (this.isInApp) {
            this.$bridge.callhandler("getUserToken", {}, (token) => {
              if (token) {
                this.$store.setstate.token(token);
                // 查看是否有待支付订单
                that.queryUnPayFn(function (data) {});
              } else {
                this.$store.setstate.token("");
                // this.$bridge.callhandler("getLogin", {}, (token) => {});
              }
            });
          }
        });
      }
    },
    activated() {

    }
  };

</script>

<style scoped="scoped" lang="less">
  /deep/ .prism-player video {
    object-fit: contain !important;
  }

  .videoBox {
    overflow: hidden;
    font-size: 0;
    width: 100% !important;
    height: 460px;
    margin-top: 40px;
  }

  // 批量购买相关ui
  .batchPop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    z-index: 99;

    .batchPopModal {
      box-sizing: border-box;
      padding: 20px 30px 25px 30px;
      max-height: 333px;
      height: auto;
      background: #222222;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;

      .text1 {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }

      .batchCloseIcon {
        width: 12px;
        height: 12px;
        position: absolute;
        top: 26px;
        right: 30px;
      }

      .buyNumDiv {
        display: flex;
        padding-top: 29px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #666;
        padding-bottom: 16px;

        .buyLeft {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F5F5F9;

          span {
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-left: 3px;
          }
        }

        .buyRight {
          .batchPlusDiv {
            display: inline-block;
            vertical-align: middle;
            width: 31px;
            height: 31px;
            text-align: center;
          }

          .batchAddDiv {
            display: inline-block;
            vertical-align: middle;
            width: 31px;
            height: 31px;
            text-align: center;
          }

          .batchPlusIcon {
            width: 14px;
            height: 2px;
            margin-top: 14px;
          }

          input {
            width: 54px;
            height: 31px;
            background: #444444;
            border-radius: 2px;
            display: inline-block;
            vertical-align: middle;
            border: none;
            outline: none;
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 31px;
            text-align: center;
            // margin: 0 15px;
          }

          .batchAddIcon {
            width: 14px;
            height: 14px;
            margin-top: 8px;
          }
        }
      }

      .numCheck {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        font-size: 16px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #E7E7E7;
        text-align: center;
        color: #E7E7E7;

        .numText {
          width: 98.5px;
          height: 35px;
          line-height: 35px;
          background: url(/static/img/boxdetail/numCheckBg.png);
          background-size: 98.5px 35px;

          &.active {
            color: #1CE89E;
            background: url(/static/img/boxdetail/hasnumCheckBg.png);
            background-size: 98.5px 35px;
          }
        }

      }

      .sureBuyBtn {
        margin-top: 25px;
        width: 100%;
        height: 45px;
        color: #282828;
        font-size: 15px;
        line-height: 45px;
        letter-spacing: 1px;
        background: url(/static/img/boxdetail/sureBuyBtnBg.png);
        background-size: 100% 100%;
        text-align: center;
        font-weight: bold;

        &.active {
          background: url(/static/img/boxdetail/sureBuyBtnBg1.png);
          background-size: 100% 100%;
        }
      }
    }
  }

  .videopo {
    position: relative;
    width: 100%;
    background: #000;
  }

  .video-box {
    position: relative;
    overflow: hidden;
    font-size: 0;
    width: 100% !important;
    height: 210px !important;
  }

  .video-boxCon {
    height: 418px;
    overflow: hidden !important;
  }

  .topHeader {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 9;
    height: 94px;
    background: #000;

    .backImg {
      width: 21px;
      height: 9px;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      left: 15px;
      top: 59px;
    }

    .title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      display: inline-block;
      width: 100%;
      margin-top: 56px;
    }

  }

  // .backBtn {
  //   position: fixed;
  //   top: 25px;
  //   left: 15px;
  //   width: 21px;
  //   height: 9px;
  //   z-index: 2;
  // }

  .sellingTimeContent {
    position: absolute;
    left: 0;
    right: 0;
    top: 94px;
    bottom: 119px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #000;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
  }

  .musicHome {
    position: fixed;
    bottom: 75px;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 99;
    width: 100%;
    height: 44px;
    background: rgba(36, 39, 41, 0.9000);

    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    line-height: 44px;

    .img2 {
      width: 6.5px;
      height: 9px;
    }
  }

  .boxStatus {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 75px;
    z-index: 99;
    background: #000000;


    .btn {
      width: 357px;
      height: 47px;
      margin: 15px auto 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      font-size: 16px;
      font-weight: bold;
      color: #013925;
      line-height: 47px;
      text-align: center;
    }

    .activebtn {
      background-image: url("/static/img/boxdetail/bgbtnfill.png");
    }
  }

  .con {
    position: relative;
    padding: 0 15px;

    .topTitle {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 19px;
      font-family: SourceHanSansCN-Heavy;
      font-weight: 800;
      color: #FFFFFF;

      .product-name {
        width: 330px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

      }

      .icon-festival {
        position: relative;
        margin: 0;
        float: left;
        margin: 3px 0 0 10px;

        .iconBubbles-wrap {
          position: absolute;
          z-index: 999;
          // display: inline-block;
          text-align: left;
          right: -3px;
          bottom: 35px;
        }

        img {
          float: left;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          margin-right: 10px;
        }

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #AAAAAA;
        }

        .line {
          width: 345px;
          height: 1px;
          opacity: 0.1;
          border-top: 1px solid #FFFFFF;
          margin: 18px 0;
        }
      }


    }
  }

  .price {
    height: 60px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0 15px 35px;

    span {
      font-size: 13px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #FFFFFF;
    }

    b {
      font-size: 22px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #FFFFFF;
    }
  }

  .conTwo {
    padding: 0 15px;

    .title {
      font-size: 19px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #FFFFFF;
      margin-bottom: 29px;
    }

    color: #83878b;
    font-weight: 300;
    font-size: 13px;
    line-height: 14px;
    font-weight: 300;
    padding: 5px 15px;

    img {
      display: block !important;
      margin: 0 auto !important;
    }

    p {
      margin: 0 !important;
    }
  }

  .vediourlImgWrap {
    text-align: center;
    position: relative;
    height: 460px;
    // margin-top: 40px;

    .vediourlImg {
      margin-top: 40px;
      width: 100%;
      height: 418px;
      object-fit: contain;
      z-index: 1 !important;
    }
  }

</style>
<style lang="less">
  p {
    margin: 0;
    padding: 0;
  }

  .sellingTimeContent {
    .page3D {
      canvas {
        touch-action: auto !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/prodDetail.vue